import React from 'react';
import { useSelector } from 'react-redux';
import { Form, Col } from 'react-bootstrap';

import PageActions from './PageActions';
import DataFilter from '@graphs/SingleStation/DataFilter';
import GraphViewRenderer from '@graphs/SingleStation/GraphView/Renderer';
import ForecastFilter from '@components/WeatherForecast/ForecastFilter';
import { selectWeatherStation } from '@stores/dataVisualizationSlice';
import { AwpContainer } from '@awp/components/Common/AwpContainer';

const SingleStationGraph = () => {
  const weatherStation = useSelector(selectWeatherStation);
  return (
    <AwpContainer>
      <div style={{ position: 'relative' }}>
        <Form>
          <Form.Row>
            <Col lg={6} md={6} sm={4}>
              <h2>Single Station Graphs</h2>
            </Col>
            <Col lg={6} md={6} sm={8}>
              <PageActions />
            </Col>
          </Form.Row>
        </Form>
        <DataFilter />
        {weatherStation && <ForecastFilter weatherStation={weatherStation} />}
        <GraphViewRenderer />
      </div>
    </AwpContainer>
  );
};

export default SingleStationGraph;
